<template>
  <div>
    <div class="chat-item chat-item--question">
      <writing-animation v-if="show.writing_1"></writing-animation>
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.question">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              <span class="question__txt">就職・転職したい時期はいつですか？</span>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <template v-if="!isDefaultFixHopeWorkTiming">
      <div
        class="chat-item chat-item--anser chat-item--select"
        :class="displayUserIconClass($parent.formData.sex)"
        :data-name="displayIconName($parent.formData.name_sei)"
        v-if="show.answer_1"
      >
        <transition name="fade">
          <div class="chat-item__inr">
            <div class="select--col1">
              <select
                v-model="hopeWorkTiming"
                title="pref"
                @change="changeHopeWorkTimingAction"
                :class="{fontBlack: isHopeWorkTimingFontBlack}"
              >
                <option value="">希望時期</option>
                <option
                  v-for="(option, key) in hopeWorkTimingItems"
                  :key="key"
                  :value="option.value"
                >{{ option.label }}</option>
              </select>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <button
            class="chat-item--anser__button"
            type="button"
            :disabled="isDisabled.hopeWorkTiming"
            @click.once="clickFixHopeWorkTiming"
          >{{ btnContent.hopeWorkTiming }}</button>
        </transition>
      </div>
      <transition name="fade">
        <div
          class="chat-item chat-item--anser"
          :class="displayUserIconClass($parent.formData.sex)"
          :data-name="displayIconName($parent.formData.name_sei)"
          v-if="show.fix_1"
        >
          <div class="chat-item__inr">
            <div class="chat-item__txt">
              <div class="chat-item__txt__inr">
                {{ fixHopeWorkTimingLabel }}
              </div>
            </div>
          </div>
        </div>
      </transition>
    </template>
    <template v-else>
      <transition name="fade">
        <div
          class="chat-item chat-item--anser"
          :class="displayUserIconClass($parent.formData.sex)"
          :data-name="displayIconName($parent.formData.name_sei)"
          v-if="show.fix_1"
        >
          <div class="chat-item__inr">
            <div class="chat-item__txt">
              <div class="chat-item__txt__inr">
                {{ fixHopeWorkTimingLabel }}
              </div>
            </div>
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import WritingAnimation from '../animations/WritingAnimation'
import GenderMixin from '../../mixins/GenderMixin'
import HopeWorkTimingMixin from '../../mixins/HopeWorkTimingMixin'
import FunctionsMixin from '../../mixins/functionsMixin'
export default {
  name: 'FormHopeWorkTiming',
  mixins: [GenderMixin, HopeWorkTimingMixin, FunctionsMixin],
  components: { WritingAnimation },
  data: function () {
    return {
      show: {
        writing_1: true,
        question: false,
        answer_1: false,
        next_1: false,
        fix_1: false,
        writing_2: false,
        confirmMessage_1: false
      },
      isDisabled: {
        hopeWorkTiming: true
      },
      isFix: {
        hopeWorkTiming: false
      },
      btnContent: {
        hopeWorkTiming: '次へ'
      },
      hopeWorkTiming: '',
      isHopeWorkTimingFontBlack: false
    }
  },
  computed: {
    fixHopeWorkTimingLabel: function () {
      return this.$parent.formData.hope_work_timing !== null
        ? this.hopeWorkTimingItems
          .find(e => e.value === this.$parent.formData.hope_work_timing)
          .label
        : ''
    },
    isDefaultFixHopeWorkTiming: function () {
      const url = new URL(window.location.href)
      const params = url.searchParams
      const defaultValue = params.get('hope_work_timing')
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.hopeWorkTiming = defaultValue !== null ? Number(defaultValue) : ''
      return defaultValue !== null
    }
  },
  mounted: function () {
    setTimeout(function () {
      this.show.writing_1 = false
      this.show.question = true
      this.autoScroll()
      setTimeout(function () {
        if (!this.isDefaultFixHopeWorkTiming) {
          this.show.answer_1 = true
        } else {
          this.clickFixHopeWorkTiming()
        }
        this.autoScroll()
      }.bind(this), 300)
    }.bind(this), 1000)
  },
  methods: {
    changeHopeWorkTimingAction: function () {
      this.isHopeWorkTimingFontBlack = this.hopeWorkTiming !== ''
      this.isDisabled.hopeWorkTiming = this.hopeWorkTiming === ''
    },
    clickFixHopeWorkTiming: function () {
      this.show.answer_1 = false
      this.isFix.hopeWorkTiming = true
      this.isDisabled.hopeWorkTiming = true
      this.$emit('form-fix-hope-work-timing', this.hopeWorkTiming)
      this.show.fix_1 = true
      this.autoScroll()
      setTimeout(function () {
        this.$emit('form-next')
      }.bind(this), 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.fade {
  &-enter-active, &-leave-active {
    will-change: opacity;
    transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
  &-enter, &-leave-to {
    opacity: 0;
  }
}
.fontBlack {
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/FormHopeWorkTiming.vue